export default __webpack_public_path__ + "static/media/ubicacion.c7175f6c.svg";